import { useEffect, useRef, useState } from 'react'

type ScrollDirection = 'up' | 'down' | null

interface UseScrollDirectionProps {
  threshold?: number
  containerRef?: React.RefObject<HTMLDivElement | null>
}

interface UseScrollDirectionResult {
  scrollDirection: ScrollDirection
}

export const useScrollDirection = ({
  threshold = 5,
  containerRef,
}: UseScrollDirectionProps = {}): UseScrollDirectionResult => {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>(null)
  const lastScrollY = useRef(0)

  useEffect(() => {
    const handleContainerScroll = (event: Event) => {
      const target = event.target as HTMLElement
      const scrollY = target.scrollTop

      if (Math.abs(scrollY - lastScrollY.current) < threshold) {
        return
      }

      const direction = scrollY > lastScrollY.current ? 'down' : 'up'
      setScrollDirection(direction)
      lastScrollY.current = scrollY
    }

    // Используем переданный ref вместо поиска через querySelector
    const container = containerRef?.current
    if (container) {
      lastScrollY.current = container.scrollTop || 0
      container.addEventListener('scroll', handleContainerScroll, {
        passive: true,
      })
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleContainerScroll)
      }
    }
  }, [containerRef, threshold])

  return {
    scrollDirection,
  }
}
